import React from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import GridItem from '../../Grid/GridItem.js';
import GridContainer from '../../Grid/GridContainer.js';
import CustomInput from '../../CustomInput/CustomInput.js';
import Button from '../../CustomButtons/Button.js';
import Card from '../../Card/Card.js';
import { connect } from 'react-redux';
import { updatePassword as getUpdateUser } from '../../../store/actions/user/User';
import CardHeader from '../../Card/CardHeader.js';
import CardBody from '../../Card/CardBody.js';
import CardFooter from '../../Card/CardFooter.js';

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

function ChangePassword(props) {
  const [userState, setUserState] = React.useState({
    userId: localStorage.getItem('userId'),
    oldPassword: '',
    newPassword: ''
  });

  const handleChange = (event) => {
    setUserState({ ...userState, [event.target.name]: event.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.getUpdateUser(userState);
    props.history.push('/user');
  };

  const classes = useStyles();
  return (
    <>
      <Card>
        <CardHeader style={{ background: '#34BA92' }}>
          <h4 className={classes.cardTitleWhite}>Change your password</h4>
          <p className={classes.cardCategoryWhite}>Create a new one</p>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                labelText="Actual Password"
                id="oldPassword"
                name="oldPassword"
                onChange={handleChange}
                value={userState.oldPassword}
                type="password"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText="New password"
                id="newPassword"
                name="newPassword"
                onChange={handleChange}
                value={userState.newPassword}
                type="password"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button style={{ background: '#34BA92' }} onClick={handleSubmit}>
            Update Password
          </Button>
        </CardFooter>
      </Card>
    </>
  );
}

const mapDispatchWithProps = (dispatch) => {
  return {
    getUpdateUser: (data) => dispatch(getUpdateUser(data))
  };
};

export default connect(null, mapDispatchWithProps)(ChangePassword);
